
abstract class Locale {
    abstract translate(text: string): string;
}

export default Locale;